import store from "store/store"

const wrapSuccess = (funcToDispatch, cb) => (resp) => {
  const { dispatch } = store
  dispatch(funcToDispatch(resp))
  if (cb) {
    cb()
  }
}

export default wrapSuccess
